import { useMutation } from "@apollo/client";
import Button from "components/base/Button";
import { Alert } from "components/base/Toast";
import { START_PROCESSING_PRODUCTION_PLAN } from "./graphql";

const StartProcessingView = ({ plan, onCompleted, odooUrl, companyId }) => {
  const [startProcessing, startProcessingRes] = useMutation(
    START_PROCESSING_PRODUCTION_PLAN,
    {
      onCompleted() {
        Alert("success", "Plan is now being processed.");
        onCompleted();
      },
      onError(error) {
        Alert("error", error.message);
      },
    },
  );

  return (
    <div>
      <div className=" space-y-2">
        <div>
          Are you sure to Start Processing this Plan: <b>{plan.name}</b>
        </div>

        {plan.planType === "AB_LTD_SALES_ORDER" && (
          <div className="font-semibold text-orange-600">
            Note that you need to Confirm the{" "}
            <a
              href={`${odooUrl}/web#id=${plan.odooObject.objectId}&menu_id=408&cids=${
                companyId
              }&action=312&model=sale.order&view_type=form`}
              rel="noreferer"
              target="_blank"
            >
              {plan.odooObject.objectName}
            </a>{" "}
            in Odoo before processing ⚠️.
          </div>
        )}

        {plan.planType === "AB_INTERNAL_TRANSFER" && (
          <div className="font-semibold text-orange-600">
            Note that you need to Make as Todo for this internal transfer{" "}
            <a
              href={`${odooUrl}/odoo/17/action-350/${plan.odooObject.objectId}?cids=${
                companyId
              }`}
              rel="noreferer"
              target="_blank"
            >
              {plan.odooObject.objectName}
            </a>{" "}
            in Odoo before processing ⚠️.
          </div>
        )}

        <div className="opacity-70 text-sm">
          Once the plan start processing, WIS will use Odoo data for stock
          computing. The stock consumed by this plan will be replaced by Odoo
          MO.
        </div>
      </div>

      <hr />

      <div className="mt-2">
        <Button
          onClick={() => startProcessing({ variables: { id: plan.id } })}
          loading={startProcessingRes.loading}
        >
          Yes, Start Processing
        </Button>
      </div>
    </div>
  );
};

export default StartProcessingView;
